import { WorkflowListItem } from "@/pages/Messaging/Workflows/types";
import React from "react";
export const WorkflowsContext = React.createContext<{
  workflows: WorkflowListItem[];
  setWorkflows: React.Dispatch<React.SetStateAction<WorkflowListItem[]>>;
  fetch: () => void;
}>({
  workflows: [],
  setWorkflows: () => {},
  fetch: () => {}
});
